import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  flex-direction: column;
  gap: 18px;

  border: 1px solid #ccc;
  padding: 24px;

  color: #274060;

  @media screen and (max-width: 991px) {
     opacity:0;
     width:0;
  }

  html.dark & {
    background-color: #1f2937;
    border-color: #374151;
    color: #e2e8f0;
  }
`;

export const Button = styled.div`
  display: flex;
  flex-direction: line;
  gap: 10%;
  width: 100%;
`;

export const Avatar = styled.img`
  width: 48px;
  height: 48px;
  object-fit: cover;
`

export const Name = styled.h2`
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  text-align: center;

  font-size: 18px;
  font-weight: 600;

  html.dark & {
    color: #e2e8f0;
  }
`

export const Description = styled.span`
  font-size: 12px;

  html.dark & {
    color: #94a3b8;
  }
`